import {
  getAssetDisplayTitle,
  getAssetFlightTimesStart,
  getAssetShortPath,
  getAssetTeaserDescription,
  isAssetUpcoming,
  isLiveStream,
  type SvpTag,
} from '../shared/helpers/assetHelpers.ts';
import { RESTRICTED_TAGS } from '../consts.ts';
import { config } from '../config.ts';

import type {
  SvpAsset,
  SvpAssetAdditional,
} from '@vgtv/api-client/lib/svp_asset';

export const getAssetPublishedDate = (asset: SvpAsset) => {
  if (isLiveStream(asset) || isAssetUpcoming(asset)) {
    return undefined;
  }

  return getAssetFlightTimesStart(asset) || asset.published;
};

export const isMachineTag = (provider: string, tag: string) => {
  if (provider === 'vgtv') {
    return /^vg:/i.test(tag);
  }

  return false;
};

export const getAssetDisplayTags = (tags: SvpTag[]) => {
  const restrictedTags = RESTRICTED_TAGS[config.provider] ?? [];

  return tags.filter(
    (tag) =>
      !restrictedTags.includes(tag.id) &&
      tag.tag &&
      !isMachineTag(config.provider, tag.tag)
  );
};

/**
 * Returns a subset of asset properties to be used on various components, e.g.
 * AssetsList, AssetsSlider, etc.
 */
export function getAssetProps(asset: SvpAssetAdditional) {
  const duration = isAssetUpcoming(asset) ? undefined : asset.duration;

  const publishedDate = getAssetPublishedDate(asset);

  const title = getAssetDisplayTitle(asset);
  const description = getAssetTeaserDescription(asset);
  const shortPath = getAssetShortPath(asset);

  return {
    duration,
    publishedDate,
    title,
    shortPath,
    description,
  };
}
